export const KeywordSearchService = Symbol.for('KeywordSearchService');
